import { VEncryptionMethods, VStartEncryptRequest, VStartEncryptResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class StartEncryptEndpoint extends EncryptedEndpoint {
    async getRequestInit({ parentFileId = '' }) {
        const requestBytes = VStartEncryptRequest.encode({
            parentFileId,
            supportedEncryptionMethods: [
                VEncryptionMethods.SIMPLE,
                VEncryptionMethods.TRANSIENT
            ]
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VStartEncryptResponse.decode(responseBytes);
    }
}
export const startEncryptionEndpoint = new StartEncryptEndpoint({
    path: '/encryptions',
    method: 'POST',
    sideEffect: true,
    body: {},
    schema: VStartEncryptResponse
});
